import { useEffect } from "react";
import { useSelector } from "react-redux";
import Chart from "react-apexcharts";
import { useDashboardStore } from "../../../hooks";
import { LoadingData, ErrorMessage } from "../../ui";
import { optionsProcedureCancellations } from "../../data";

export const ProcedureCancellationsChart = () => {
  // Datos del hook ----------------------------------------//
  const { isLoading, data, errorMessage } = useSelector(
    (state) => state.dashboard.procedureCancellations
  );

  const { getDataProcedureCancellations } = useDashboardStore();
  // States ------------------------------------------------//
  // Formulario --------------------------------------------//
  // Funciones ---------------------------------------------//
  // Efectos -----------------------------------------------//
  useEffect(() => {
    if (!data) {
      getDataProcedureCancellations();
    }
  }, [data, getDataProcedureCancellations]);

  return (
    <div className="card shadow border-0 p-4 h-100">
      {isLoading && <LoadingData />}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      {data && (
        <>
          <h6 className="align-items-center mb-0">
            Número de cancelación de procedimientos mensuales
          </h6>
          <Chart
            options={optionsProcedureCancellations}
            series={data.series}
            type="bar"
            width="100%"
            height={350}
          />
        </>
      )}
    </div>
  );
};
